import { Component, OnInit } from '@angular/core';
import { MiscService } from 'src/app/_service/misc.service';
import { SharedService } from 'src/app/_service/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-plan-package-add-edit',
  templateUrl: './plan-package-add-edit.component.html',
  styleUrls: ['./plan-package-add-edit.component.css']
})
export class PlanPackageAddEditComponent implements OnInit {
  public Editor = ClassicEditor; planPackageForm: FormGroup; submitted = false; loading: boolean = false; planId: any = '';
  constructor(private activatedRoute: ActivatedRoute, public miscapi: MiscService, public sharedapi: SharedService, private formBuilder: FormBuilder, private router: Router) {
    this.planPackageForm = this.formBuilder.group({
      'plan_name': [null, Validators.required],
      'plan_amount': [null],
      'plan_mrp_amount': [null],
      'plan_amount_for_member': [null],
      'status': [null, Validators.required],
      'test_name_availed': [null],
      'online_gp': [null],
      'online_surgeon': [null],
      'online_dentists': [null],
      'surgeon_opd': [null],
      'dentist_opd': [null],
      'tests_discount': [null],
      'aligners_discount': [null],
      'description': [null],
      'full_description':[null]
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['plan_id']) {
        this.planId = params['plan_id'];
        this.patchPlanPackageData(this.planId);
      }
    });

    this.Editor.defaultConfig = {
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'insertTable',
          '|',
          'undo',
          'redo'
        ]
      },
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      language: 'en'
    };

  }
  ngOnInit(): void {
  }

  get f() { return this.planPackageForm.controls; }

  async createPlanPackage() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.planPackageForm.invalid) {
      this.loading = false;
      return;
    }
    this.planId = this.activatedRoute.snapshot.paramMap.get('plan_id');
    this.planPackageForm.value.id = parseInt(this.planId);
    await this.miscapi.savePlanPackage(this.planPackageForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigateByUrl('/plan-package');
        this.planPackageForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async patchPlanPackageData(planId) {
    await this.miscapi.getPlanPackageEditData(this.planId).subscribe((response: any) => {
      if (response.status) {
        this.planPackageForm.patchValue({
          'plan_name': response.data.plan_name,
          'plan_amount': response.data.plan_amount,
          'plan_mrp_amount': response.data.plan_mrp_amount,
          'plan_amount_for_member': response.data.plan_amount_for_member,
          'status': response.data.status,
          'test_name_availed': response.data.test_name_availed,
          'online_gp': response.data.online_gp,
          'online_surgeon': response.data.online_surgeon,
          'online_dentists': response.data.online_dentists,
          'surgeon_opd': response.data.surgeon_opd,
          'dentist_opd': response.data.dentist_opd,
          'tests_discount': response.data.discount_tests,
          'aligners_discount': response.data.aligners,
          'description': response.data.description,
          'full_description': response.data.full_description
          
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


}
